import type { TFunction } from "i18next";

import { getFieldKindStrategy } from "features/shared/lib/technical-config-tab/fieldKindStrategies";
import { getTableTypicalColumn } from "utils/components";

import type { RoomTypeCatalogItem } from "../model/types";

import { type CatalogColumnFieldDefinition, getCatalogColumnDefinitions } from "./roomConfigFieldDefinitions";

const getCatalogColumnLabel = (t: TFunction, field: CatalogColumnFieldDefinition) => {
  const labelKey = field.labelKey ?? field.key;
  if (labelKey === "roomTypeName" || labelKey === "color") {
    return t(`TechnicalData.room.columns.${labelKey}`);
  }
  return t(`TechnicalData.room.fields.${labelKey}`);
};

export const getRoomCatalogTableHeaders = (t: TFunction) =>
  getCatalogColumnDefinitions().map((field) =>
    getTableTypicalColumn({
      dataKey: field.key,
      label: getCatalogColumnLabel(t, field),
      valueClassName: "font-ds-body-regular-xs",
      valueTransformation: (row: RoomTypeCatalogItem) =>
        getFieldKindStrategy(field.kind).formatCatalogValue(row[field.key], t),
    })
  );
